module.exports = __webpack_public_path__ + "img/Entia-Lineas-de-transmision-distribucion-electrica-3.94b8d107.webp";